export enum DeliverableTableType {
  FINANCIAL = 'Financial',
  TECHNICAL = 'Technical',
}
